import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DiscountTemplatesService } from '../discount-templates.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateCustmizedDiscountTemplatesComponent } from '../create-custmized-discount-templates/create-custmized-discount-templates.component';
import { ICustomizedDiscountTemplatesDto } from 'src/app/models/backend/customized-discount-template';
import { PagedListingComponentBase, PagedRequestDto } from 'src/app/shared/components/paged-listing-component-base';
import { CreateDomesticCustmizedDiscountTemplatesComponent } from '../create-domestic-custmized-discount-templates/create-domestic-custmized-discount-templates.component';
import { CreateProductCustmizedDiscountTemplatesComponent } from '../create-product-custmized-discount-templates/create-product-custmized-discount-templates.component';
import { IPagedCustomizedDiscountTemplateResultRequestDto } from 'src/app/models/backend';
import { ProductType } from 'src/app/models/enums';

@Component({
  selector: 'app-custmized-discount-templates',
  templateUrl: './custmized-discount-templates.component.html',
  styleUrls: ['./custmized-discount-templates.component.scss']
})
export class CustmizedDiscountTemplatesComponent extends PagedListingComponentBase<ICustomizedDiscountTemplatesDto>{

  internationalDiscounts: any
  domesticDiscounts: any
  pridDiscounts: any

  internationalTotalCount:number;
  domesticTotalCount:number;
  pridTotalCount:number;

  loader = false;
  domesticloader = false;
  pridloader = false;
  protected override delete(entity: ICustomizedDiscountTemplatesDto): void {
    throw new Error('Method not implemented.');
  }
  ID: number
  request = {
    skipCount: 0,
    maxResultCount: 100,
    keyword: "",
    discountTemplateId: 0,
    isInvloveDeletedItems: false,
    productType: 0,
  }
  customDiscount: any
  Role:any
  constructor(public activatedRoute: ActivatedRoute,
    public customService: DiscountTemplatesService,
    private modalService: NgbModal,
  ) {
    super();
    this.activatedRoute.params.subscribe(params => { this.ID = params['id'].replace('id', '') });
    this.Role=localStorage.getItem("RoleType")
    this.loader=false
    //this.LoadData()
    // this.request.productType=ProductType.InternationalTopUp;
    // this.internationalDiscounts(this.request,1);
    // this.request.productType=ProductType.DomesticTopUp;
    //  this.LoadDomestic(this.request,1)
    //  this.request.productType=ProductType.PridExpress;
    //  this.LoadPrid(this.request,1)
  }

  override async ngOnInit() {
    this.request.discountTemplateId=this.ID
    this.request.maxResultCount=100;
    this.request.productType=ProductType.InternationalTopUp;
   await this.loadInternational(this.request,1);
    this.request.productType=ProductType.DomesticTopUp;
   await  this.LoadDomestic(this.request,1)
     this.request.productType=ProductType.PridExpress;
    await this.LoadPrid(this.request,1)
  }
  protected override list(request: IPagedCustomizedDiscountTemplateResultRequestDto, pageNumber: number): void {
    // this.loader = true
    // request.discountTemplateId=this.ID
    // request.maxResultCount=100
  //  this.loadInternational(request,1);
  //   this.LoadDomestic(this.request,1)
  //   this.LoadPrid(this.request,1)

  }

  loadInternational(request: IPagedCustomizedDiscountTemplateResultRequestDto,pageNumber) {
    this.loader = true;
    request.productType=ProductType.InternationalTopUp
    this.customService.GetAllDiscountTemplateCustomized(request).subscribe((res: any) => {
      this.customDiscount = res.items
      this.internationalTotalCount=res.totalCount;
      this.showPaging(res, pageNumber)
      this.loader = false
    })
  }
  LoadDomestic(request: IPagedCustomizedDiscountTemplateResultRequestDto,pageNumber) {
    this.domesticloader = true
    request.discountTemplateId=this.ID
    request.productType=ProductType.DomesticTopUp
    request.maxResultCount=100
    this.customService.GetAllDiscountTemplateCustomized(request).subscribe((res: any) => {
      console.log(res)
      this.domesticDiscounts = res.items
      this.domesticTotalCount=res.totalCount;
      this.showPaging(res, pageNumber)
      this.domesticloader = false
    })
  }
  LoadPrid(request: IPagedCustomizedDiscountTemplateResultRequestDto,pageNumber) {
    this.pridloader = true
    request.productType=ProductType.PridExpress
    this.customService.GetAllDiscountTemplateCustomized(this.request).subscribe((res: any) => {
      console.log(res)
      this.pridDiscounts = res.items
      this.pridTotalCount=res.totalCount;
      this.showPaging(res, pageNumber)
      this.pridloader = false
    })
  }
  Delete(Id) {
    this.loader=true
    this.customService.DeleteDiscountTemplateCustomized(Id).subscribe((res:any)=>{
      console.log(res)
      this.list(this.request,1)
      this.loader=false
    })
  }
  openCreateModal() {
    this.customService.templateId = this.ID
    const modalRef = this.modalService.open(CreateCustmizedDiscountTemplatesComponent, {
      size: 'lg', windowClass: 'mymodal', backdrop: 'static'
    });
    modalRef.closed.subscribe((o: { refresh: boolean }) => o.refresh && this.isRefresh(true));

  }
  isRefresh(refresh: boolean) { 
    
    if (refresh === true) 
      this.getDataPage(1); 
    this.request.productType=ProductType.InternationalTopUp;
    this.request.discountTemplateId=this.ID;
    this.loadInternational(this.request,1);

   }

  openDomesticCreateModal() {
    this.customService.templateId = this.ID
    const modalRef = this.modalService.open(CreateDomesticCustmizedDiscountTemplatesComponent, {
      size: 'lg', windowClass: 'mymodal', backdrop: 'static',keyboard:false
    });
    
    modalRef.closed.subscribe((o: { refresh: boolean }) => o.refresh && this.LoadDomestic(this.request,1));
  }
  openProductCreateModal() {
    this.customService.templateId = this.ID
    const modalRef = this.modalService.open(CreateProductCustmizedDiscountTemplatesComponent, {
      size: 'sm', windowClass: 'mymodal', backdrop: 'static'
    });
    modalRef.closed.subscribe((o: { refresh: boolean }) => o.refresh && this.LoadPrid(this.request,1));
  }

  onPageChanged(pageNumber: number) {
    this.request = {
      skipCount: (pageNumber - 1) * 100,
      maxResultCount: 100,
      keyword: "",
      discountTemplateId: this.ID,
      isInvloveDeletedItems: true,
      productType: ProductType.InternationalTopUp,

    }
    //this.list(this.request, pageNumber,)
    this.loadInternational(this.request,pageNumber);
    this.getDataPage(pageNumber);
  }
  onPageChangedDomestic(pageNumber: number) {
    this.request = {
      skipCount: (pageNumber - 1) * 100,
      maxResultCount: 100,
      keyword: "",
      discountTemplateId: this.ID,
      isInvloveDeletedItems: true,
      productType: ProductType.DomesticTopUp,

    }
    this.LoadDomestic(this.request, pageNumber,)
    this.getDataPage(pageNumber);
  }
  onPageChangedPrid(pageNumber: number) {
    this.request = {
      skipCount: (pageNumber - 1) * 100,
      maxResultCount: 100,
      keyword: "",
      discountTemplateId: this.ID,
      isInvloveDeletedItems: true,
      productType: ProductType.PridExpress,

    }
    this.LoadDomestic(this.request, pageNumber,)
    this.getDataPage(pageNumber);
  }
  FilterInternational(keyword) {
    this.request = {
      keyword: keyword,
      isInvloveDeletedItems: false,
      skipCount: 0,
      maxResultCount: 100,
      discountTemplateId:this.customService.id,
      productType:ProductType.InternationalTopUp
    }
    this.customService.GetAllDiscountTemplateCustomized(this.request).subscribe((res: any) => {
      this.customDiscount = res.items;
      this.showPaging(res, 1)
    })
  }

  FilterDomestic(keyword) {
    this.request = {
      keyword: keyword,
      isInvloveDeletedItems: false,
      skipCount: 0,
      maxResultCount: 100,
      discountTemplateId:this.customService.id,
      productType:ProductType.DomesticTopUp
    }
    this.customService.GetAllDiscountTemplateCustomized(this.request).subscribe((res: any) => {
      this.domesticDiscounts = res.items;
      this.showPaging(res, 1)
    })
  }

  FilterPrid(keyword) {
    this.request = {
      keyword: keyword,
      isInvloveDeletedItems: false,
      skipCount: 0,
      maxResultCount: 100,
      discountTemplateId:this.customService.id,
      productType:ProductType.PridExpress
    }
    this.customService.GetAllDiscountTemplateCustomized(this.request).subscribe((res: any) => {
      this.pridDiscounts = res.items;
      this.showPaging(res, 1)
    })
  }
}
